/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { formatDate } from "@fullcalendar/react";
import React, { useEffect, useRef } from "react";

function NewEventForm({ newEvent, setNewEvent, handleSaveEvent, calendarAPI }) {
  const labelInputRef = useRef();
  useEffect(() => {
    if (newEvent.id) {
      labelInputRef.current.select();
    }
  }, [newEvent.id]);

  return (
    <div className="new-event-form">
      <h3>Create New Event </h3>

      {newEvent.allDay ? (
        <div className="mb-3">
          All day <br />
          Start:{" "}
          {formatDate(newEvent.start, {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
          <br />
          End:{" "}
          {formatDate(newEvent.end, {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </div>
      ) : (
        <div className="mb-3">
          Start:
          {formatDate(newEvent.start, {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}{" "}
          <br />
          End:
          {formatDate(newEvent.end, {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      )}
      <div className="mb-3">
        <label className="form-label">Label</label>
        <input
          ref={labelInputRef}
          type="text"
          className="form-control"
          placeholder="Event Label"
          value={newEvent?.title}
          onChange={(e) =>
            setNewEvent((prev) => ({
              ...prev,
              title: e.target.value,
            }))
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Description </label>
        <textarea
          type="text"
          className="form-control"
          placeholder="Event description"
          value={newEvent?.description}
          onChange={(e) =>
            setNewEvent((prev) => ({
              ...prev,
              description: e.target.value,
            }))
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Capacity </label>
        <input
          type="number"
          className="form-control"
          placeholder="Capacity"
          value={newEvent?.extendedProps.capacity}
          onChange={(e) =>
            setNewEvent((prev) => ({
              ...prev,
              extendedProps: {
                capacity: e.target.value,
              },
            }))
          }
        />
      </div>

      <div className="float-end">
        <button
          type="button"
          className="btn btn-primary me-1"
          onClick={handleSaveEvent}
        >
          <i className="fa fa-save" /> Create
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => {
            setNewEvent(null);
            calendarAPI.unselect();
          }}
        >
          <i className="fa fa-remove" /> Cancel
        </button>
      </div>
    </div>
  );
}

export default NewEventForm;
